import styles from "./styles.module.css";
import { IconPicker } from "components/layout/icons/IconPicker";
import { ModuleProps } from "components/props/ModuleProps";
import { Loader } from "@progress/kendo-react-indicators";


interface ModuleLoaderProps {
    module: ModuleProps;
}

export const ModuleLoader = ({
    module
    }:ModuleLoaderProps) => {

    return (
        <div className={styles.bar}>
            <div className={styles.barContent}>
                <div className={styles.loader}>
                    <Loader type="infinite-spinner" />
                </div>
                <div className={styles.loaderIcon}>
                    <IconPicker icon={module.icon} size={24} />
                </div>
            </div>
        </div>
    );
}
